import { render, staticRenderFns } from "./SegmentSelector.vue?vue&type=template&id=ab9fbc96&scoped=true&"
import script from "./SegmentSelector.vue?vue&type=script&lang=js&"
export * from "./SegmentSelector.vue?vue&type=script&lang=js&"
import style0 from "./SegmentSelector.vue?vue&type=style&index=0&id=ab9fbc96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab9fbc96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
